import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import bemClass from './../../../utils/bemClass'
import prettyText from './../../../utils/prettyText'

import './ThisWeek.css'

const cn = bemClass('ThisWeek')

class Item extends PureComponent {
    render() {
        const { className, title, date, hour } = this.props

        return (
            <div className={`${cn('item')} ${className}`}>
                <div
                    className={cn('title')}
                    dangerouslySetInnerHTML={prettyText(title)}
                />
                <div className={cn('date')}>
                    {date}
                    <br />
                    {hour}
                </div>
            </div>
        )
    }
}

Item.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    date: PropTypes.string,
    hour: PropTypes.string,
}

Item.defaultProps = {
    className: '',
    title: '',
    date: '',
    hour: '',
}

export default Item



// WEBPACK FOOTER //
// ./src/components/FrontPage/ThisWeek/Item.jsx